import { useEffect, useState, type RefObject } from 'react';

export type AnimDurumu = 'sabit' | 'bekle' | 'oyna';

/**
 * Prerender (Playwright) ciktisinda animasyon yok: ogeler sabit gorunur.
 * "Hareketi azalt" burada KAPATMAZ: Windows'ta animasyon efektleri kapali olan herkes bu durumda ve
 * logo cizimi yer degistiren bir hareket degil. Zip/halka gibi hareketler CSS'te o ayarda kapanir.
 */
export function animasyonKapali(): boolean {
  if (typeof window === 'undefined') return true;
  return navigator.webdriver === true;
}

/**
 * Oge ekrana girince bir kez oynar. Ilk durum 'sabit' (JS calismazsa oge gorunur kalir);
 * oge ekran disindaysa 'bekle'ye gecer (gizlenir), gorununce 'oyna'.
 */
export function useGorunceOyna(ref: RefObject<HTMLElement | null>, esik = 0.5): AnimDurumu {
  const [durum, setDurum] = useState<AnimDurumu>('sabit');

  useEffect(() => {
    const el = ref.current;
    if (!el || animasyonKapali() || typeof IntersectionObserver === 'undefined') return;
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      setDurum('oyna');
      return;
    }
    setDurum('bekle');
    const io = new IntersectionObserver(
      (girdiler) => {
        if (girdiler[0].isIntersecting) {
          setDurum('oyna');
          io.disconnect();
        }
      },
      { threshold: esik }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, esik]);

  return durum;
}
